import {z} from '@hono/zod-openapi';

/** Raw supplier feed, without tenant identities or calculated dealer/customer prices. */
export const supplierCatalogSearchInputSchema = z
  .object({
    brand: z.enum(['HONDA', 'NISSAN']),
    currency: z.literal('CZK'),
    oemPattern: z.string().max(100).optional(),
    namePattern: z.string().max(100).optional(),
    searchType: z.enum(['EQUALS', 'LIKE', 'STARTS_WITH', 'ENDS_WITH']).default('EQUALS'),
    normalized: z.boolean().default(false),
    activeOnly: z.boolean().default(true),
    limit: z.number().int().min(1).max(500).default(100),
    offset: z.number().int().min(0).max(50000).default(0),
  })
  .strict()
  .openapi('SupplierCatalogSearchInput');
export type SupplierCatalogSearchInput = z.infer<typeof supplierCatalogSearchInputSchema>;
